import React from 'react';
import ReactDOM from 'react-dom/client';

import App from './main/app/App';
import { ThemeProvider } from '@mui/material';
import { theme } from './theme';
import './i18n';
import './index.css';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <ThemeProvider theme={theme}>
      <App />
    </ThemeProvider>
  </React.StrictMode>
);
